import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HlmBadgeImports } from '@spartan-ng/helm/badge';

/** Where a piece of the brand shows up. */
export type BrandPlace = 'app' | 'storefront' | 'pdf' | 'checkout' | 'members';

const PLACE_LABELS: Record<BrandPlace, string> = {
  app: 'Gutschein-App',
  storefront: 'Shopseite',
  pdf: 'Gutschein-PDF',
  checkout: 'Bezahlseite',
  members: 'Mitgliederliste des Netzwerks',
};

/**
 * "Erscheint auf: …" — tells the user why a field matters, e.g. that the logo
 * is used by the storefront and the PDFs although the voucher app doesn't show it.
 */
@Component({
  selector: 'app-brand-usage',
  imports: [HlmBadgeImports],
  template: `
    <p class="text-muted-foreground flex flex-wrap items-center gap-1.5 text-xs">
      <span>Erscheint auf:</span>
      @for (place of places(); track place) {
        <span hlmBadge variant="outline" class="font-normal">{{ labels[place] }}</span>
      }
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandUsageComponent {
  readonly places = input.required<BrandPlace[]>();
  protected readonly labels = PLACE_LABELS;
}
